import React from 'react';
import {useSelector} from 'react-redux';
import informationMessageService from '../../services/informationMessage/InformationMessageService';
import {captureError} from '../../utils/log';
import InformationMessageView from './InformationMessageView';

function InformationMessageContainer() {
  const currentLocale = useSelector(state => state.i18n.locale);
  const [messages, setMessages] = React.useState(null);

  React.useEffect(() => {
    informationMessageService.getInformationMessage()
      .then(response => setMessages(response))
      .catch(error => captureError('Error while getting information message on dashboard', error));
  }, []);

  return (
    <InformationMessageView message={messages ? messages[currentLocale] : null}/>
  );
}

export default InformationMessageContainer;
